import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase credentials missing. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env file');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Event {
  id?: string;
  title: string;
  start_date: string;
  end_date?: string;
  location?: string;
  priority?: 'High' | 'Medium' | 'Low';
  partnership_angle?: string;
  description?: string;
  notes?: string;
  owner?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Objective {
  id?: string;
  content: string;
  category?: string;
  created_at?: string;
  updated_at?: string;
}

// Date utilities to handle timezone issues
// Parse date string (YYYY-MM-DD) as local date, not UTC
export const parseLocalDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

// Format date for input field (YYYY-MM-DD)
export const formatDateForInput = (dateString: string): string => {
  return dateString.split('T')[0]; // Just take the date part, ignore time
};

// Format date for display
export const formatDateForDisplay = (dateString: string): string => {
  const date = parseLocalDate(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

